/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finals_FinishInputs */



/**
* | output |
* | --- |
* | "Finish Finals" |
*
* @param {Finals_FinishInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finals_finish = /** @type {((inputs?: Finals_FinishInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finals_FinishInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminer la finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finalizar finales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Finalizar Finais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Concludi Finali")
	return /** @type {LocalizedString} */ ("Finish Finals")
});